import { Injectable } from "@angular/core";
import { DwTaskItem, formatDateTimeToLocal, getMomentValue } from "@devwareapps/devware-cap";
import { CheckRideRequestEntity, CheckRideRequestSubStatusAllItems, CheckRideWorkflowAllItems } from "../../../meta-data/app-meta-data.service";
import * as moment from "moment";

@Injectable({
    providedIn: 'root'
})
export class SchoolTaskService {


    status: CheckRideRequestSubStatusAllItems;


    SchoolTaskDefinitions: SchoolTaskDefinition[] = [
        {
            taskType: SchoolTaskType.todaysCheckrides,
            titleTextSuffix: ' today',
            toolipTextSuffix: '[is,are] booked for today',
            iconClass: 'fa fa-check dw-blue',
            navigateUrlBase: '/school-checkrides',
            bookingTile: 'booked',
            filterDisplay: 'Today\'s Checkrides',
            filterFunc: (checkride) => this.isForToday(checkride) && this.isBooked(checkride)
        },
        {
            taskType: SchoolTaskType.upcomingCheckrides,
            titleTextSuffix: ' later this week',
            toolipTextSuffix: '[is,are] booked later this week',
            iconClass: 'fa fa-check dw-green',
            navigateUrlBase: '/school-checkrides',
            bookingTile: 'booked',
            filterDisplay: 'Checkrides this week',
            filterFunc: (checkride) => this.isForThisWeek(checkride) && this.isBooked(checkride)
        },
        {
            taskType: SchoolTaskType.pendingCheckrides,
            titleTextSuffix: ' Pending Approval',
            toolipTextSuffix: '[is,are] waiting approval from the DPE',
            iconClass: 'fa fa-check dw-orange',
            navigateUrlBase: '/school-checkrides',
            bookingTile: '',
            filterDisplay: 'Checkrides Pending DPE Approval',
            filterFunc: (checkride) => checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingApproval || checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingApprovalPayment
        },
        {
            taskType: SchoolTaskType.needsAdditionalInfoCheckrides,
            titleTextSuffix: ' Needs Additional Info',
            toolipTextSuffix: '[needs,need] additional information from the school',
            iconClass: 'fa fa-check dw-orange',
            navigateUrlBase: '/school-checkrides',
            bookingTile: '',
            filterDisplay: 'Checkrides Needs Additional Info',
            filterFunc: (checkride) => checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.AdditionalInformationNeeded
        },
        {
            taskType: SchoolTaskType.requiresAdditionalInfoCheckrides,
            titleTextSuffix: ' Requires Additional Info',
            toolipTextSuffix: '[requires,require] additional information for the examiner to accept the booking',
            iconClass: 'fa fa-check dw-orange',
            navigateUrlBase: '/school-checkrides',
            bookingTile: '',
            filterDisplay: 'Requires Needs Additional Info',
            filterFunc: (checkride) => checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.RequiresAdditionalInfo
        },
        {
            taskType: SchoolTaskType.pendingRescheduleCheckrides,
            titleTextSuffix: ' Pending Reschedule',
            toolipTextSuffix: '[is,are] waiting to be rescheduled',
            iconClass: 'fa fa-check dw-orange',
            navigateUrlBase: '/school-checkrides',
            bookingTile: '',
            filterDisplay: 'Checkrides Pending Reschedule',
            filterFunc: (checkride) => checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingReschedule
        },
          {
            taskType: SchoolTaskType.newDataProposed,
            titleTextSuffix: ' New Date Proposed',
            toolipTextSuffix: '[is,are] need to be reviewed',
            iconClass: 'fa fa-check dw-orange',
            navigateUrlBase: '/school-checkrides',
            bookingTile: '',
            filterDisplay: 'Checkrides With New Data Proposed',
            filterFunc: (checkride) => checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.NewDateProposedByExaminer
        },
        {
            taskType: SchoolTaskType.pendingOutcomeCheckrides,
            titleTextSuffix: ' Pending Outcome',
            toolipTextSuffix: '[needs,need] to have their outcome updated',
            iconClass: 'fa fa-check dw-orange',
            navigateUrlBase: '/school-checkrides',
            bookingTile: 'booked',
            filterDisplay: 'Checkrides Pending Outcome',
            filterFunc: (checkride) => checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingOutcome && checkride.CheckRideWorkflowId == CheckRideWorkflowAllItems.SchoolWorkflowManualNoPilexosExaminer
        },
        {
            taskType: SchoolTaskType.recentlyCancelled,
            titleTextSuffix: ' Recently Cancelled',
            toolipTextSuffix: '[has,have] been cancelled this week',
            iconClass: 'fa fa-check dw-orange',
            navigateUrlBase: '/school-checkrides',
            bookingTile: 'all',
            filterDisplay: 'Checkrides Cencelled',
            filterFunc: (checkride) => 
                checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.Cancelled && this.isForThisWeek(checkride) 
               
        }
    ]

    public isScheduledCheckride(checkride: CheckRideRequestEntity): boolean {

        switch (checkride.CheckRideRequestSubStatusId) {
            //case CheckRideRequestSubStatusAllItems.Cancelled:
            case CheckRideRequestSubStatusAllItems.Completed:
            case CheckRideRequestSubStatusAllItems.Rejected:
            case CheckRideRequestSubStatusAllItems.Deleted:
            case CheckRideRequestSubStatusAllItems.Draft:
            case CheckRideRequestSubStatusAllItems.PendingPayment:

                return false;
        }

        return true;
    }

    isBooked(checkride: CheckRideRequestEntity): boolean {
        switch (checkride.CheckRideRequestSubStatusId) {
            case CheckRideRequestSubStatusAllItems.Accepted:
            case CheckRideRequestSubStatusAllItems.AllDetailsComplete:
            case CheckRideRequestSubStatusAllItems.AcceptedPendingPayment:
            case CheckRideRequestSubStatusAllItems.RequiresAdditionalInfo:
                return true;
        }

        return false;
    }

    getCheckrideTasks(checkrides: CheckRideRequestEntity[], showAllTasks: boolean = false): DwTaskItem[] {
        const tasks: DwTaskItem[] = [];

        for (const taskDefinition of this.SchoolTaskDefinitions) {
            const task = this.buildCheckrideTask(checkrides, taskDefinition, showAllTasks);

            if (task) {
                tasks.push(task)
            }
        }

        return tasks;
    }

    buildCheckrideTask(checkrides: CheckRideRequestEntity[], taskDefinition: SchoolTaskDefinition, showAllTasks: boolean): DwTaskItem {
        const filteredCheckrides = checkrides.filter(checkride => taskDefinition.filterFunc(checkride));

        if (filteredCheckrides.length == 0 && !showAllTasks) {
            return null;
        }

        const checkrideText = this.pluralizeWord('Checkride', 'Checkrides', filteredCheckrides.length);

        let navigateUrl = taskDefinition.navigateUrlBase || '/school-checkrides';

        const urlParams: string[] = [];

        urlParams.push(`filter=${taskDefinition.taskType}`);

        if (taskDefinition.bookingTile) {
            urlParams.push(`tile=${taskDefinition.bookingTile}`);
        }

        navigateUrl += `?${urlParams.join('&')}`;

        const count = filteredCheckrides.length;

        const task: DwTaskItem = {
            iconClass: taskDefinition.iconClass,
            taskTitle: `${count} ${checkrideText} ${this.pluralizeSentence(taskDefinition.titleTextSuffix, count)}`,
            tooltip: `${count} ${checkrideText} ${this.pluralizeSentence(taskDefinition.toolipTextSuffix, count)}`,
            navigateUrl: navigateUrl
        }

        return task;
    }

    isForToday(checkride: CheckRideRequestEntity): boolean {
        const scheduleDateTimeLocal = formatDateTimeToLocal(checkride.ScheduledDateTime, true, true);

        if (!scheduleDateTimeLocal) {
            return false;
        }

        const scheduleDateTime = getMomentValue(scheduleDateTimeLocal, true, true);

        const now = moment();

        if (scheduleDateTime.isSame(now, 'day')) {
            return true;
        }

        return false;
    }

    isForThisWeek(checkride: CheckRideRequestEntity): boolean {
        const scheduleDateTimeLocal = formatDateTimeToLocal(checkride.ScheduledDateTime, true, true);

         if (!scheduleDateTimeLocal) {
            return false;
        }

        const scheduleDateTime = getMomentValue(scheduleDateTimeLocal, true, true);
        const now = moment().add(1, 'days');
        const sat = moment().weekday(6); // 6 is saturday

        if (scheduleDateTime.isSameOrAfter(now, 'day') && scheduleDateTime.isSameOrBefore(sat, 'day')) {
            return true;
        }

        return false;
    }

    private pluralizeWord(word: string, pluralword: string, count: number): string {
        if (count == 1) {
            return word;
        }

        return pluralword;
    }

     private pluralizeSentence(sentence : string, count: number): string {

        const startBracket = sentence.indexOf('[');
        const endBracket = sentence.indexOf(']');

        if (startBracket == -1 || endBracket == -1 || endBracket < startBracket) {
            return sentence;
        }

        const fullBracket = sentence.substring(startBracket, endBracket + 1);
        const pluralPart = sentence.substring(startBracket + 1, endBracket);

        const parts = pluralPart.split(',');

        const replacementvalue = (count == 1) ? parts[0] : parts[1];

        sentence = sentence.replace(fullBracket, replacementvalue);

        return sentence;
    }
}


export enum SchoolTaskType {
    todaysCheckrides = 'todaysCheckrides',
    upcomingCheckrides = 'upcomingCheckrides',
    pendingCheckrides = 'pendingCheckrides',
    needsAdditionalInfoCheckrides = 'needsAddiionalInfoCheckrides',
    requiresAdditionalInfoCheckrides = 'requiresAddiionalInfoCheckrides',
    pendingRescheduleCheckrides = 'pendingRescheduleCheckrides',
    pendingOutcomeCheckrides = 'pendingOutcomeCheckrides',
    newDataProposed = 'newDataProposed',
    recentlyCancelled = 'recentlyCancelled'
}


export interface SchoolTaskDefinition {
    taskType: SchoolTaskType;
    titleTextSuffix: string,
    toolipTextSuffix: string,
    iconClass: string;
    navigateUrlBase?: string;
    bookingTile?: string;
    filterFunc: (CheckRideEntity) => boolean;

    filterDisplay: string;
}
